import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export function HomeApplicationsCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Borrower Applications</CardTitle>
      </CardHeader>
      <CardContent>
        Access referrals from Boundless and review borrower applications,
        explore business data rooms, and leverage lending analytics for informed
        decisions.
      </CardContent>
      <CardFooter>
        <Button asChild>
          <Link to="/lender/applications/list">View Applications</Link>
        </Button>
      </CardFooter>
    </Card>
  )
}
